module.exports = __webpack_public_path__ + "img/image83.ff50af47.jpg";